import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="35c23whp4t7xc">
      <Routes data-id="element-1" data-mp="3k9ktfm9mvp5u">
        <Route path="/" element={<Home data-id="element-3" data-mp="3k8jgtdcyyum0" />} data-id="element-2" data-mp="3k9b5e485fs2s" />
        {/* Old address keeps working and forwards to Home */}
        <Route path="/HonduransinLA" element={<Navigate to="/" replace data-id="element-5" data-mp="3fb155f7ki1ab" />} data-id="element-4" data-mp="3f9yjblp3qp19" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-7" data-mp="2rk44wzp4wsew" />} data-id="element-6" data-mp="2rkx49flrkfn0" />
      </Routes>
    </BrowserRouter>;
}